const truncateDecimals = (num: number, decimals: number) => Math.trunc(num * 10 ** decimals) / 10 ** decimals;

export const formatNumber = (
	number: number,
	options?: {
		separateThousands?: boolean;
		integersOnly?: boolean;
	},
	decimals?: number,
	minDecimals?: number,
) => {
	let num = number;
	const decimalSeperator = typeof window !== 'undefined' && localStorage ?
		localStorage.getItem('decimalSeperator') ?? '.' :
		'.';

	if (options?.integersOnly) {
		num = truncateDecimals(num, 0);
	}

	const formatted = new Intl.NumberFormat(decimalSeperator === '.' ? 'en-US' : 'da-DK', {
		minimumFractionDigits: minDecimals ?? decimals,
		maximumFractionDigits: decimals,
		useGrouping: options?.separateThousands ?? true,
	}).format(num);

	return formatted;
};

export const formatAndRoundNumber = (number: number, decimals: number, minDecimals?: number) => {
	return formatNumber(number, undefined, decimals, minDecimals);
};
